import { render, staticRenderFns } from "./EventModalCatalogHeader.vue?vue&type=template&id=4dd6abd7&scoped=true"
import script from "./EventModalCatalogHeader.vue?vue&type=script&lang=js"
export * from "./EventModalCatalogHeader.vue?vue&type=script&lang=js"
import style0 from "./EventModalCatalogHeader.vue?vue&type=style&index=0&id=4dd6abd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd6abd7",
  null
  
)

export default component.exports